import React from 'react'
import "./ContactusContainer.css"
import { useSelector } from 'react-redux';
function ContactusContainer({layout}) { 
    const { currentLocal } = useSelector((state) => state.currentLocal);
   

    return (
        <section className='contact_container'>
            <div className='contact_box'>
<p className='text-center fw-bold fs-4'>{currentLocal.home.Getintouch}</p>
<p className='text-center  '>{currentLocal.home.whatsapp} : <a className='text-black'target="_blank" rel="noopener noreferrer" href={`https://wa.me/+201228200565`}>+201228200565 </a></p>

            </div>
        </section>)
}

export default ContactusContainer